import {
  AccountInfo,
  InteractionType,
  IPublicClientApplication,
  SilentRequest,
} from "@azure/msal-browser";
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";
import { ReactNode, useEffect, useRef, useState } from "react";
import { loginRequest } from "../../authConfig";
import {
  Backdrop,
  Box,
  CircularProgress,
  circularProgressClasses,
  CircularProgressProps,
  Stack,
  Typography,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { setMsalToken, setUserInfo } from "../../redux/auth/authSlice";
import { localStorageCeUserId, localStorageCeUserName } from "../../utils/constants";
import TagManager from 'react-gtm-module';
const authRequest = {
  ...loginRequest,
};

export const PageLayout: React.FC<{ children: ReactNode }> = (props) => {
  const accountRef = useRef<AccountInfo | null>(null);
  const dispatch = useDispatch();

  const { accounts, instance } = useMsal();
  const accountInfo = instance.getActiveAccount();

  const [renderChildren, setRenderChildren] = useState<boolean>(false);

  useEffect(() => {
    const getSilentToken = async (instance: IPublicClientApplication, accountRef: any) => {
      await instance.initialize();
      const silentRequest: SilentRequest = {
        account: accountRef.current!,
        scopes: ["User.Read"], // Add the necessary scopes here
      };
      try {
        const silentToken = (await instance.acquireTokenSilent(silentRequest))
          .accessToken;
        dispatch(setMsalToken({ silentToken }));
      } catch (err) {
        throw new Error(`Failed to fetch MsalToken: ${err}`);
      }
    }

    const account = accounts.at(-1);
    if (account) {
      getSilentToken(instance, accountRef);
      accountRef.current = account;
      dispatch(setUserInfo({ accountInfo }));
      localStorage.setItem(
        localStorageCeUserId,
        account?.username ? account?.username : ""
      );
      localStorage.setItem(
        localStorageCeUserName,
        account?.name ? account?.name : ""
      );
/*       if (account?.name && account?.username) {
        const tagManagerArgs = {
          gtmId: process.env.REACT_APP_FULLSTORY_GTM || '',
          dataLayer: {
            userId: account?.username,
            displayName: account?.name,
          },
        }
        TagManager.initialize(tagManagerArgs);
      } */
      setRenderChildren(true);
    } else {
      setRenderChildren(false);
    }
  }, [accounts, accountInfo, dispatch, instance]);



  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      errorComponent={HelpPage}
      loadingComponent={Loading}
      authenticationRequest={authRequest}
    >
      {renderChildren ? props.children : <Loading />}
    </MsalAuthenticationTemplate>
  );
};

const Loading = () => (
  <Backdrop
    sx={{
      zIndex: (theme) => theme.zIndex.drawer + 1,
    }}
    open={true}
  >
    <Spinner />
  </Backdrop>
);

const Spinner = (props: CircularProgressProps) => (
  <>
    <CircularProgress
      variant="determinate"
      size={96}
      thickness={4}
      {...props}
      value={100}
    />
    <CircularProgress
      variant="indeterminate"
      disableShrink
      sx={{
        color: (theme) => theme.palette.primary.main,
        animationDuration: "550ms",
        position: "absolute",
        [`& .${circularProgressClasses.circle}`]: {
          strokeLinecap: "round",
        },
      }}
      size={96}
      thickness={4}
      {...props}
    />
  </>
);

function HelpPage() {
  const message = "Something wrong ocurred!";
  return (
    <TemplatePage message={message}>
      <Stack alignItems="center" justifyContent="center">
        <Typography variant="h6" color="inherit">
          Your Lennar account does not have the required access to continue
          using this application.
        </Typography>

        <Typography variant="h6" color="inherit">
          Please feel free to contact the Lennar Service Desk at 1-800-588-9411
          or by email at ServiceDesk@Lennar.com.
        </Typography>
      </Stack>
    </TemplatePage>
  );
}

function TemplatePage({
  message,
  children,
}: {
  message: string;
  children: React.ReactNode;
}) {
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Stack alignItems="center" rowGap={2}>
        <Typography variant="h5" color="inherit" noWrap>
          {message}
        </Typography>

        {children}
      </Stack>
    </Box>
  );
}
